import React, { useState } from "react";
import Image from "next/legacy/image";

import LoginForm from "./auth/LoginForm/LoginForm";
import RegisterForm from "./auth/RegisterForm/RegisterForm";
import GuestForm from "./auth/GuestForm/GuestForm";
import ForgotPasswordForm from "./auth/ForgotPasswordForm/ForgotPasswordForm";


const LoginView: React.FC<{ setClose: (data: boolean) => void }> = ({ setClose }) => {
  const [selectedView, setSelectedView] = useState("login");

  const handleViewSwitch = (view: string) => {
    setSelectedView(view);
  };

  return (
    <div className="md:w-[480px] sm:w-screen xs:w-screen w-screen max-w-[480px] h-[max-content]">
      <div className="w-full min-h-[480px] h-[max-content] bg-white rounded-lg p-4 pt-8">
        <div className="w-full">
          <div className="w-36 h-14 relative m-auto">
            <Image src={"/svgs/logo.svg"} layout="fill" alt="Logo" />
          </div>
        </div>
        {selectedView === "login" && <LoginForm onSwitchView={handleViewSwitch} onClose={() => setClose(false)} />}
        {selectedView === "signUp" && <RegisterForm onSwitchView={handleViewSwitch} onClose={() => setClose(false)} />}
        {selectedView === "guest" && <GuestForm onSwitchView={handleViewSwitch} onClose={() => setClose(false)} />}
        {selectedView === "forgotPass" && <ForgotPasswordForm onSwitchView={handleViewSwitch} />}
      </div>
    </div>
  );
};

export default LoginView;
